import { api } from "@api/api";
import { ProductPlan } from "@modules/defaultProducts/types/productPlan";
import { ProductPlanFormValues } from "@modules/defaultProducts/types/productPlan";

export async function createProductPlanService(data: ProductPlanFormValues): Promise<ProductPlan> {
  const { data: productPlan } = await api.post<ProductPlan>("v1/default_plan_admin/", data);

  return productPlan;
}
